<template>
    <div class="sustainability-has">
        <p class="indent">La salute e la sicurezza di ogni individuo che lavori in Alcomet è la nostra maggiore priorità. Non giungiamo a compromessi quando si tratti di proteggere la vita umana o di evitare infortuni. Una attenta valutazione del rischio è effettuata per ogni posto di lavoro ed è aggiornata regolarmente con particolare attenzione sui rischi potenziali e sulle misure di prevenzione. Tutti i dipendenti ed i lavoratori a contratto partecipano regolarmente a corsi per comprendere al meglio le regole di sicurezza ideate dall’azienda. Ci assicuriamo che siano applicate le migliori scelte ingegneristiche, le migliori tecnologie e le migliori pratiche allo scopo di offrire  il più alto livello di protezione per i lavoratori di Alcomet. Indagini interne sono usualmente svolte a seguito del verificarsi di ogni singolo problema al fine di identificarne le cause ed eliminare il rischio che si ripeta</p>
        <p class="indent">La politica per la salute e la sicurezza dell’azienda si basa sulla certificazione ISO 45001:2018 per la gestione della salute e della sicurezza sul lavoro, acquisita da Alcomet nel 2019. </p>
        <p>
          <a href="/static/files/A-POLICY-FOR-HEALTHY-AND-SAFE-LABOUR-CONDITIONS.pdf" target="_blank">A POLICY FOR HEALTHY AND SAFE LABOUR CONDITIONS</a>
        </p>
        <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};
</script>

<style scoped>
.sustainability-has > p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
a {
  text-decoration: underline;
}
@media screen and (max-width: 1000px) {
  .sustainability-has {
    padding-bottom: 20px;
  }
  .sustainability-has > p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sustainability/HealthAndSafety.vue